<div class="profile_image" [style.width]="width" [style.height]="height">
  <img [src]="sourcefile" alt="" />
</div>
